import { useState, useMemo, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

// type
import { SubTopArea } from "../../../model/subPageTopArea"
import { SubPageTab } from "../../../model/subPageTabArea"

// components
import SubPageTopArea from "../../../components/SubPageTopArea"
import SubPageTabArea from "../../../components/SubPageTabArea"

// pages
import KsCert from "./KsCert";
import NepCert from "./NepCert";
import NetCert from "./NetCert";
import GreenTechCert from "./GreenTechCert";

// images
import bannerBg03 from "../../../images/certification/banner_bg03.png"

const TechCertCommon = () => {
   const location = useLocation();
   const queryString = Number(location.search.substring(1));

   // TopArea, Tab
   const subPageInfo: SubTopArea = {
      title: "인증 분야",
      category: [
         { name: "조달인증", link: "/certification/procurement" },
         { name: "품질인증", link: "/certification/quality-cert" },
         { name: "기술인증", link: "/certification/tech-cert" },
         { name: "경영인증", link: "/certification/management-cert" },
      ],
      bannerText: "우수조달컨설팅은 <span class='point'>확실한 신용과 빅데이터</span>를 활용하여 <br/><span class='point'>정확한 컨설팅</span>을 진행합니다 ",
      currentInfo: {
         name: "기술인증",
         bgImg: bannerBg03,
      },
   };

   const subPageTab: SubPageTab[] = [
      { name: "신제품인증(NEP)" },
      { name: "신기술인증(NET)" },
      { name: "KS인증" },
      { name: "녹색기술인증" },
   ];

   const [tabIndex, setTabIndex] = useState(queryString ? queryString : 0);

   useEffect(() => {
      setTabIndex(queryString ? queryString : 0)
   }, [queryString])

   const components = useMemo(() => [
      <NepCert />,
      <NetCert />,
      <KsCert />,
      <GreenTechCert />,
   ], []);

   const returnComponent = useCallback(() => {
      return components[tabIndex];
   }, [tabIndex, components]);

   return (
      <div>
         <SubPageTopArea info={subPageInfo} />
         <SubPageTabArea data={subPageTab} setTabIndex={setTabIndex} currentId={queryString} />
         {returnComponent()}
      </div>
   );
}

export default TechCertCommon;
